interface LoadingSpinnerProps {
	theme?: Theme;
}

export const LoadingSpinner = ({ theme = "light" }: LoadingSpinnerProps) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<circle
			className={`${theme === "light" ? "stroke-gray-300" : "stroke-secondary-dark-icon-bg"} origin-center fill-none stroke-[15px]`}
			strokeLinecap="square"
			cx="100"
			cy="100"
			r="70"
		/>
		<circle
			className="stroke-primary-600 origin-center fill-none stroke-[15px] "
			strokeLinecap="square"
			strokeDasharray="100 1000"
			strokeDashoffset="0"
			cx="100"
			cy="100"
			r="70"
		>
			<animateTransform
				type="rotate"
				attributeName="transform"
				calcMode="spline"
				dur="2"
				values="0;360"
				keyTimes="0;1"
				keySplines="0 0 1 1"
				repeatCount="indefinite"
			/>
		</circle>
	</svg>
);
